import {CSSProperties, FC} from 'react';


export interface IIconQuestionBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconQuestionBmw: FC<IIconQuestionBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm1.333 11H11v2.333h2.333V15Zm-.952-8.333c-2.201 0-3.464 1.017-3.787 3.052l2.058.274c.155-1.167.717-1.75 1.688-1.75 1.002 0 1.504.433 1.504 1.301 0 .456-.205.863-.615 1.221a4.96 4.96 0 0 1-.698.476C11.802 11.67 11 12.436 11 13.509V14h2.333v-.503c0-.313.235-.897.791-1.257.557-.359.966-.646 1.23-.932.47-.505.705-1.102.705-1.791 0-.881-.292-1.563-.875-2.046-.643-.536-1.577-.804-2.803-.804Z" clipRule="evenodd" />
        </svg>
    );
};
